import { render, staticRenderFns } from "./AddFamilyForm.vue?vue&type=template&id=e9cbf070&scoped=true&"
import script from "./AddFamilyForm.vue?vue&type=script&lang=js&"
export * from "./AddFamilyForm.vue?vue&type=script&lang=js&"
import style0 from "./AddFamilyForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddFamilyForm.vue?vue&type=style&index=1&id=e9cbf070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cbf070",
  null
  
)

export default component.exports